import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../Router/all_routes";
import PurchaseInvoiceServices from "../../services/PurchaseInvoice";
import { ErrorToaster, SuccessToaster } from "../components/toaster/Toaster";
import Form from "./components/form";

const CreatePurchase = () => {

  const route = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Submit Form
  const createPurchaseInvoice = async (payload) => {
    console.log('payload:', payload)
    setLoading(true)
    try {
      await PurchaseInvoiceServices.createPurchaseInvoice(payload)
      SuccessToaster('Create Successfully')
      navigate(route?.purchases)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Purchase</h4>
              <h6>Create new purchase invoice</h6>
            </div>
          </div>
        </div>
        <Form onSubmit={createPurchaseInvoice} loading={loading} />
      </div>
    </div>
  );
};

export default CreatePurchase;
